import { render, staticRenderFns } from "./BookingFormModal.vue?vue&type=template&id=15a5fff0"
import script from "./BookingFormModal.vue?vue&type=script&lang=js"
export * from "./BookingFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports